import React, { useState } from "react";
import SectionDropdown from "../dropdowns/Section";

const AddStructure = ({ onClose, theme }) => {
  const [selectedSections, setSelectedSections] = useState([]);
  const [structureName, setStructureName] = useState("");

  const handleSectionChange = (selectedValues) => {
    setSelectedSections(selectedValues);
  };

  return (
    <div>
      <SectionDropdown value={selectedSections} onChange={handleSectionChange} />
      <div className="mt-4">
        <strong>Selected Sections:</strong>
        <ul>
          {selectedSections.map((section) => (
            <li key={section} className="flex">{section}</li>
          ))}
        </ul>
      </div>
      <label className="block mt-4 text-sm font-medium">
        Structure Name
      </label>
      <input
        type="text"
        value={structureName}
        onChange={(e) => setStructureName(e.target.value)}
        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${
          theme === "dark" ? "bg-gray-700 text-white border-gray-600" : ""
        }`}
      />
      <button
        className="bg-blue-600 text-white px-4 py-2 rounded mt-4"
        onClick={onClose}
      >
        Close
      </button>
    </div>
  );
};

export default AddStructure;
